import { Project, Workspace } from "@zirp/client";
import { useApi } from "../useApi";
import { useAuth } from "../auth/useAuth";

function emptyProject(): Project {
  return {
    workspaceId: "",
    id: "",
    name: "",
    description: "",
    ownerId: "",
    createdBy: "",
    lastEditedBy: "",
    slug: "",
    created: "",
    updated: "",
    _object: Project._object.PROJECT,
  };
}

export const useGetProject = () => {
  const projectId = useCookie("project_id");

  const loading = useState<boolean>("getProject:loading", () => false);
  const error = useState<string | null>("getProject:error", () => null);
  const project = useState<Project>("getProject:project", () => emptyProject());
  const api = useApi();

  const { authRequest } = useAuth();

  const getProject = async (workspaceId: string, id: string) => {
    try {
      error.value = null;
      loading.value = true;

      const response = await authRequest(async () => await api.projects.projectsGet(workspaceId, id));
      if (response?.success) {
        project.value = response.result;
        projectId.value = project.value.id;
        return response.result;
      }
    } catch (err) {
      error.value = "Failed to get a project";
      throw err;
    } finally {
      loading.value = false;
    }
  };

  return {
    getProject,
    loading,
    error,
    project,
  };
};
